export const APPLICATION_EXAMPLES = [
  {
    area: 'Strategy',
    situation:
      'A competitor changes the economics of your market while customers still expect the same level of service.',
  },
  {
    area: 'Innovation',
    situation:
      'A successful pilot now conflicts with existing operations, incentives, and capacity.',
  },
  {
    area: 'Leadership',
    situation:
      'A high performer is delivering results while undermining trust across the team.',
  },
  {
    area: 'Change',
    situation:
      'People support the goal but resist the new way of working when day-to-day pressure rises.',
  },
  {
    area: 'Product & portfolio',
    situation:
      'Leaders must balance investment in the core business against uncertain emerging opportunities.',
  },
  {
    area: 'Professional judgment',
    situation:
      'A complex role requires people to apply standards and policies when the right answer is not obvious.',
  },
];
